<template>
	<v-dialog
		v-model="dialog"
		max-width="600px"
		:fullscreen="$vuetify.breakpoint.xs ? true : false"
		:transition="$vuetify.breakpoint.xs ? 'scroll-y-reverse-transition' : ''"
	>
		<template v-slot:activator="{ on, attrs }">
			<v-btn
				:text="text"
				:color="text ? 'white' : 'secondary'"
				class="ml-2"
				v-bind="attrs"
				v-on="on"
			>
				<v-icon class="mr-1">mdi-plus</v-icon>
				機械登録
			</v-btn>
		</template>

		<v-card tile>
			<v-app-bar dense dark flat color="primary">
				<v-app-bar-title class="color-white">機械登録</v-app-bar-title>
				<v-spacer />
				<v-btn icon dark @click="dialog = false" color="white">
					<v-icon>mdi-close</v-icon>
				</v-btn>
			</v-app-bar>
			<ValidationError :errors="errors" />
			<v-form ref="form" v-model="valid" class="pa-2">
				<v-text-field
					label="機械名"
					v-model="machine.name"
					:rules="[rules.required]"
					class="mt-4"
					dense
					outlined
				/>
				<v-select
					v-if="!machine_type"
					label="在庫"
					v-model="machine.machine_type"
					:rules="[rules.required]"
					:items="machineTypes"
					:item-value="item.id"
					:item-text="item.name"
					class="mt-4"
					dense
					outlined
				/>
				<v-textarea label="備考" v-model="machine.memo" class="mt-4" dense outlined />
			</v-form>
			<v-card-actions>
				<v-row no-gutters class="pb-2">
					<v-col sm="4" cols="0" />
					<v-col sm="4" cols="12">
						<v-row no-gutters justify="center">
							<v-btn color="secondary" @click="submitForm" :disabled="!valid">
								<v-icon class="mr-2">mdi-plus</v-icon>
								登録する
							</v-btn>
						</v-row>
					</v-col>
					<v-col sm="4" cols="0" v-if="!$vuetify.breakpoint.xs">
						<v-row no-gutters justify="end">
							<v-btn color="grey darken-1" text @click="dialog = false"> 閉じる </v-btn>
						</v-row>
					</v-col>
				</v-row>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
import axios from "axios"
import rules from "../../../helper/rules"
import errorHandling from "../../../helper/errorHandling"
import authenticate from "../../../helper/authenticate"
import ValidationError from "../../shared/ValidationError.vue"

export default {
	props: {
		text: Boolean,
    // machine_typeがある場合、機械タイプは変更できない
		machine_type: {
			type: String,
			required: false,
		},
		machine_types: {
			type: Array,
			required: false,
			default: () => [],
		},
	},
	components: {
		ValidationError,
	},
	data() {
		return {
			machine: {
				name: null,
				machine_type: null,
				memo: null,
			},
			machineTypes: [],
			dialog: false,
			valid: false,
			errors: [],
			rules: rules,
		}
	},
	mounted() {
		if (this.machine_types.length > 0) {
			this.machineTypes = this.machine_types
		} else {
			this.getMachineTypes()
		}
		if (this.machine_type) {
			this.machine.machine_type = this.machine_type
		}
	},
	methods: {
		getMachineTypes() {
			const headers = authenticate.setHeader()
			const url = `/erp/v1/machines/new`
			axios
				.get(url, { headers })
				.then((res) => {
					this.machineTypes = res.data.machine_types
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},
		submitForm() {
			const headers = authenticate.setHeader()
			const url = `/erp/v1/machines`
			axios
				.post(url, { machine: this.machine }, { headers })
				.then((res) => {
					this.$store.dispatch("setFlash", {
						type: "notice",
						text: "機械を登録しました。",
					})
					this.$emit("create-machine", res.data.machine)
					this.$refs.form.reset()
					this.dialog = false
				})
				.catch((err) => {
					const errors = errorHandling.errorResponse(err)
					if (Array.isArray(errors)) {
						this.errors = errors
					}
				})
		},
	},
}
</script>


<style lang="scss" scoped>
.products {
	.row {
		&:not(:first-child) {
			border-top: 1px solid whitesmoke;
		}
	}
}
</style>